import type { NavDropdownItem } from '@time-line/components/types';
import { useGlobals } from 'hooks/useGlobals';
import { useIsSkincare } from 'hooks/useIsSkincare';
import { buildScienceNav, SKINCARE } from 'lib/constants/navigation';
import { useMemo } from 'react';

import { MENU_DATA } from './constants';

export const useNav = () => {
  const { data: globals } = useGlobals();
  const isSkincare = useIsSkincare();
  const pageType = isSkincare ? 'skincare' : 'supplements';
  const plpPages = globals?.siteSettings?.plp;

  const { nav } = MENU_DATA[pageType];

  const primaryNav = useMemo(() => {
    if (!plpPages) return nav.primary;

    const shopItem: NavDropdownItem = {
      type: 'dropdown',
      label: plpPages.label,
      subNav: {
        ...plpPages.subNav,
        items: [...plpPages.subNav.items, ...(isSkincare ? [] : [SKINCARE])],
      },
    };

    const scienceItem = buildScienceNav(
      globals?.siteSettings?.scienceNav?.navigationItems,
    );

    return [shopItem, ...(isSkincare ? [] : [scienceItem]), ...nav.primary];
  }, [nav.primary, plpPages, globals?.siteSettings?.scienceNav, isSkincare]);

  const accountNav = useMemo(
    () => nav.secondary.find((item) => item.name === 'account'),
    [nav.secondary],
  );

  const secondaryNav = useMemo(
    () => nav.secondary.filter((item) => item.name !== 'account'),
    [nav.secondary],
  );

  return { nav, primaryNav, accountNav, secondaryNav };
};
